import { Component } from '@angular/core';

@Component({
  selector: 'cx-store-finder',
  templateUrl: './store-finder.component.html',
})
export class StoreFinderComponent {}
